<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import Knob from "svelte-knob";
  import Income from "../../../../Data/ComponentData/DashboardData/EcommerceData/Selling.json";
</script>

{#each Income.AnnualyIncome as incomeItem}
  <Col xl="3" sm="6" class="box-col-3 chart_data_right">
    <Card cardProps="income-card card-secondary" cardBodyprops="align-items-center">
      <div slot="contentbody">
        <div class="round-progress knob-block text-center">
          <div class="progress-circle">
            <Knob
              value={incomeItem.value}
              step={10}
              strokeWidth={14}
              primaryColor={incomeItem.color}
              secondaryColor="#e9ecef"
              textColor="#121212"
            />
          </div>
          <h5>{incomeItem.price}</h5>
          <p>{incomeItem.title}</p>
        </div>
      </div>
    </Card>
  </Col>
{/each}
